// vue3-migration -- Element
import langDe from 'element-plus/es/locale/lang/de';
import translations from './translations.json';
import 'moment/locale/de';

export default {
  ...translations,
  // vue3-migration -- Element
  ...langDe,
};